import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

import Box from '@g4/boneyard/lib/Box';
import Text from '@g4/boneyard/lib/Text';
import PlainButton from '../PlainButton';

import { SlideToggle } from '../Boneyard';

import dropDownIcon from '../../images/ic-dropdown-white.svg';

const StyledList = styled.ul`
  padding-top: ${props => (props.open ? props.theme.spacing(2) : 0)};
`;

const MenuSlide = ({ mq, children, title, theme, alignIcon, ...props }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <li>
      <Box pt={4} pb={4} pl={2}>
        <PlainButton
          onClick={toggleOpen}
          alignIcon={'right'}
          icon={{
            height: 24,
            width: 24,
            src: dropDownIcon,
          }}
          iconFlip={open}
          type="tertiary"
          isOpen={open}
        >
          <Text
            size={16}
            weight={500}
            color={theme.colors.hob.topMenu.linkMobile}
          >
            {title}
          </Text>
        </PlainButton>
        <SlideToggle
          open={open}
          onToggle={toggleOpen}
          statusIndicatorIconAltAttribute="statusIndicatorIconAltAttribute"
        >
          <StyledList open={open}>{children}</StyledList>
        </SlideToggle>
      </Box>
    </li>
  );
};

MenuSlide.propTypes = {
  children: PropTypes.node.isRequired,
  mq: PropTypes.object,
  title: PropTypes.string,
  alignIcon: PropTypes.string,
  theme: PropTypes.object,
};

export default withTheme(MenuSlide);
